const whiteSpaceRegex = /[\s]{2,}|[\r\n\t]+/g;

export default whiteSpaceRegex;
